import React, { useEffect, useState } from 'react';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import WizardPaso3 from '../components/WizardPaso3';
import { Content, Title, Subtitle, Form, FormGroup, Label, Select, DireccionBox, Icon } from '../styles/formStyles';
import PageContainer from '../components/pageContainer';


const SeleccionaProfSuc = () => {
  const navigate = useNavigate();
  const [sucursales, setSucursales] = useState([]);
  const [odontologos, setOdontologos] = useState([]);
  const [direccion, setDireccion] = useState('');
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');
  const [profesionalSeleccionado, setProfesionalSeleccionado] = useState('');
  const { setContextData, setOdontologoRut, setPaginaOrigen, resetOdontRuts, contextData } = useAppAgendaContext();

  /* URL API */
  const API_BASE_URL = 'https://api-dev.morapavic.cl';

  useEffect(() => {
    const fetchSucursales = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${API_BASE_URL}/sucursal/listaSucursales`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSucursales(response.data.datos);
      } catch (error) {
        console.error('Error al obtener la lista de sucursales:', error);
      }
    };

    fetchSucursales();
  }, []);

  useEffect(() => {
    /* console.log('🔄 Reseteando odontRuts solo si se está iniciando un nuevo flujo...'); */
    if (!contextData.odontologoRut) {
      resetOdontRuts();
    }
  }, []);

  const handleSucursalChange = async (e) => {
    const sucursalId = e.target.value;
    const sucursalSeleccionadaObj = sucursales.find((suc) => suc.sucId === parseInt(sucursalId));
    setSucursalSeleccionada(sucursalId);

    if (sucursalSeleccionadaObj) {
      setDireccion(sucursalSeleccionadaObj.sucDireccion);

      setContextData((prev) => ({
        ...prev,
        sucursalId,
        sucursalNombre: sucursalSeleccionadaObj.sucNombre || 'Sin información',
      }));
    } else {
      setDireccion('');
      setContextData((prev) => ({
        ...prev,
        sucursalId: null,
        sucursalNombre: null,
      }));
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_BASE_URL}/odontologo/listaOdontologosSucursal/${sucursalId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const odontologosOrdenados = response.data.datos.sort((a, b) => a.odontNombres.localeCompare(b.odontNombres));
      setOdontologos(odontologosOrdenados);
    } catch (error) {
      console.error('Error al obtener la lista de odontólogos:', error);
      setOdontologos([]);
    }
  };

  const handleProfesionalChange = (e) => {
    const profesionalId = e.target.value;
    setProfesionalSeleccionado(profesionalId);

    if (!profesionalId) {
      console.error('❌ Error: Profesional no seleccionado.');
      return;
    }

    resetOdontRuts();
    setOdontologoRut(profesionalId);

    setContextData((prev) => ({
      ...prev,
      odontologoRut: profesionalId,
      paginaOrigen: 'SeleccionaProfSuc',
    }));

    /* console.log("✅ Odontólogo seleccionado:", profesionalId); */
  };

  const handleSiguienteClick = () => {
    if (profesionalSeleccionado) {
      setPaginaOrigen('SeleccionaProfSuc');
      setContextData((prev) => ({
        ...prev,
        paginaOrigen: 'SeleccionaProfSuc',
      }));
      navigate('/SeleccionaFecHora');
    } else {
      console.error('❌ Error: Profesional no seleccionado.');
    }
  };

  return (
    <PageContainer onBack={() => navigate('/SeleccionaTipoHora')} onNext={handleSiguienteClick} nextDisabled={!profesionalSeleccionado}>
      <WizardPaso3 />
      <Content>
        <Title>Seleccionar Sucursal y <strong>Profesional</strong></Title>
        <Subtitle>Selecciona el profesional con el que prefieres agendar tu hora.</Subtitle>
        <Form>
          <FormGroup>
            <Label htmlFor="clinica"><strong>Clínica Dental</strong></Label>
            <Select id="clinica" name="clinica" value={sucursalSeleccionada} onChange={handleSucursalChange}>
              <option value="" disabled>Seleccione Sucursal</option>
              {sucursales.map(sucursal => (
                <option key={sucursal.sucId} value={sucursal.sucId}>
                  {sucursal.sucNombre}
                </option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label htmlFor="profesional"><strong>Nombre de Profesional</strong></Label>
            <Select id="profesional" value={profesionalSeleccionado} onChange={handleProfesionalChange} disabled={!sucursalSeleccionada}>
              <option value="" disabled>Seleccione Profesional</option>
              {odontologos.map(odontologo => (
                <option key={odontologo.odontRut} value={odontologo.odontRut}>
                  {odontologo.odontNombres} {odontologo.odontApellidos ? odontologo.odontApellidos : ''}
                </option>
              ))}
            </Select>
          </FormGroup>
        </Form>
        <DireccionBox>
          <Icon className="fas fa-map-marker-alt" />
          <div>
            <strong>Dirección Clínica</strong>
            <p>{direccion || 'Selecciona una sucursal para ver la dirección'}</p>
          </div>
        </DireccionBox>
      </Content>
    </PageContainer>
  );
};
export default SeleccionaProfSuc;

